module.exports = __webpack_public_path__ + "iphone18pro-silver.dc28c6fd.png";